import { jsx as e } from "react/jsx-runtime";
import { cn as a } from "./designsystem-ui-react47.js";
function m({ className: t, children: r }) {
  return /* @__PURE__ */ e("div", { className: a("tw-flex tw-items-start tw-justify-between tw-gap-2", t), children: r });
}
export {
  m as CardHeader
};
